module.exports = __webpack_public_path__ + "img/icon-instagram-color.7bc8c5f2.svg";